import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {
  keyboardHandler,
  useGlobalKeyDown,
  useInput
} from '../../containers/hooks'
import {Popup} from '../common/popup/popup'

interface Props {
  close: () => void
  add: (name: string) => void
}

const AddCompanyBase = (props: Props) => {
  const {close, add} = props

  const [name, setName] = useInput('')
  useGlobalKeyDown({
    escape: () => {
      close()
      return true
    }
  })

  const bem = Util.bemFrom('add-company')

  const submit = () => {
    if (name) {
      add(name)
    }
  }
  const footer = (
    <div className={bem('submit', {disabled: !name})} onClick={submit}>
      {Lang.msg.companies.add}
    </div>
  )
  return (
    <Popup
      width={460}
      autoHeight={true}
      close={close}
      title={Lang.msg.companies.add}
      footer={footer}
    >
      <div className={bem('warn-alert')}>{Lang.msg.common.attention}!</div>
      <div className={bem('warn-title')}>{Lang.msg.companies.warn1}</div>
      <div className={bem('warn-descr')}>{Lang.msg.companies.warn2}</div>

      <div className={bem('form')}>
        <input
          autoFocus
          className={bem('input')}
          type="text"
          placeholder={Lang.msg.companies.namePlaceholder}
          onChange={setName}
          value={name}
          onKeyDown={keyboardHandler({escape: close, enter: submit})}
        />
      </div>
    </Popup>
  )
}

export const AddCompany = (props: Props) => {
  return <AddCompanyBase {...props} />
}
